export default __webpack_public_path__ + "static/media/DSCN8369.c1d5e668.JPG";